import { render } from "./JobItemsPanel.vue?vue&type=template&id=1b1df8ca&scoped=true"
import script from "./JobItemsPanel.vue?vue&type=script&lang=js"
export * from "./JobItemsPanel.vue?vue&type=script&lang=js"

import "./JobItemsPanel.vue?vue&type=style&index=0&id=1b1df8ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1df8ca"]])

export default __exports__